import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { addTask } from 'components/tasks/api';
import { moveScrollToTop } from 'helpers/scrolling';
import { enableTab } from  'helpers/dom_helper';

import MobileTaskForm from './mobile_task_form';

import 'bundles/tasks/index/tasks.scss';

const MobileNewTaskFormStyleWrapper = ({
  callListsAccess,
  currentDatabaseId,
  currentUserId,
  defaultAssociatedModels,
  databaseMembers,
  hideByProjectSelect,
  hideContactSelect,
  hideProjectSelect,
  hidePropertySelect
}) => {
  const [errors, setErrors] = useState();

  const handleSave = (task) => {
    addTask(task).then(() => {
      moveScrollToTop();
      window.location.reload();
    }).catch((errors) => {
      setErrors(errors);
    });
  };

  const handleCancel = () => {
    enableTab('todo-task-list', ['js-mobile-tabs', 'js-mobile-page-header']);
  };

  return (
    <div className="tasks-mobile-content">
      <MobileTaskForm
        assigneeOptions={databaseMembers}
        callListsAccess={callListsAccess}
        currentDatabaseId={currentDatabaseId}
        defaultAssociatedModels={defaultAssociatedModels}
        defaultTaskAssignee={databaseMembers.find(member => member.id === currentUserId)}
        errors={errors}
        hideByProjectSelect={hideByProjectSelect}
        hideContactSelect={hideContactSelect}
        hideProjectSelect={hideProjectSelect}
        hidePropertySelect={hidePropertySelect}
        indexView
        multipleProjects={true}
        newTaskFormStyling
        onCancel={handleCancel}
        onSave={handleSave}
      />
    </div>
  );
};

MobileNewTaskFormStyleWrapper.propTypes = {
  callListsAccess: PropTypes.bool.isRequired,
  currentDatabaseId: PropTypes.number,
  currentUserId: PropTypes.number.isRequired,
  databaseMembers: PropTypes.array.isRequired,
  defaultAssociatedModels: PropTypes.array,
  hideByProjectSelect: PropTypes.bool,
  hideContactSelect: PropTypes.bool,
  hideProjectSelect: PropTypes.bool,
  hidePropertySelect: PropTypes.bool
};

export default MobileNewTaskFormStyleWrapper;
